export default {
  'component.globalHeader.search': 'Search',
  'component.globalHeader.search.example1': 'Search example 1',
  'component.globalHeader.search.example2': 'Search example 2',
  'component.globalHeader.search.example3': 'Search example 3',
  'component.globalHeader.help': 'Help',
  'component.globalHeader.notification': 'Notification',
  'component.globalHeader.notification.empty':
    'You have viewed all notifications.',
  'component.globalHeader.message': 'Message',
  'component.globalHeader.message.empty': 'You have viewed all messsages.',
  'component.globalHeader.event': 'Event',
  'component.globalHeader.event.empty': 'You have viewed all events.',
  'component.noticeIcon.clear': 'Clear',
  'component.noticeIcon.cleared': 'Cleared',
  'component.noticeIcon.empty': 'No notifications',
  'component.noticeIcon.view-more': 'View more',
  'component.avatarDropdown.user': 'User',
  'component.avatarDropdown.changePassword': 'Change Password',
  'component.avatarDropdown.logout': 'Logout',
  'component.avatarDropdown.changePassword.title': 'Change Password',
  'component.avatarDropdown.changePassword.ok': 'OK',
  'component.avatarDropdown.changePassword.cancel': 'Cancel',
  'component.avatarDropdown.changePassword.oldPassword.label': 'Old Password',
  'component.avatarDropdown.changePassword.oldPassword.required': 'Please enter your old password',
  'component.avatarDropdown.changePassword.oldPassword.min': 'Password must be at least 6 characters',
  'component.avatarDropdown.changePassword.oldPassword.placeholder': 'Please enter your old password',
  'component.avatarDropdown.changePassword.newPassword.label': 'New Password',
  'component.avatarDropdown.changePassword.newPassword.required': 'Please enter your new password',
  'component.avatarDropdown.changePassword.newPassword.length': 'Password must be 6-20 characters',
  'component.avatarDropdown.changePassword.newPassword.placeholder': 'Please enter your new password',
  'component.avatarDropdown.changePassword.confirmPassword.label': 'Confirm Password',
  'component.avatarDropdown.changePassword.confirmPassword.required': 'Please confirm your new password',
  'component.avatarDropdown.changePassword.confirmPassword.mismatch': 'The two passwords do not match',
  'component.avatarDropdown.changePassword.confirmPassword.placeholder': 'Please enter your new password again',
  'component.avatarDropdown.changePassword.success': 'Password changed successfully, please login again',
  'component.avatarDropdown.changePassword.failure': 'Failed to change password',
};
